<template>
  <div class="md-layout">
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-20">
      <md-card>
        <md-card-header class="md-card-header-icon">
          <div class="card-icon">
            <md-icon>filter_list</md-icon>
          </div>
          <h4 class="title">Filter</h4>
        </md-card-header>
        <md-card-content class="filter-column">
          <div v-if="searchList.length > 0">
            <a v-on:click.stop="clearReferenceList()" class="filter-badge">
              Reference list
              <span>x</span>
            </a>
          </div>
          <div v-if="searchString.length > 0">
            <a v-on:click.stop="clearSearch()" class="filter-badge">
              Search "{{searchString}}"
              <span>x</span>
            </a>
          </div>
          <div v-for="(filter, index) in this.$store.state.filters" :key="index">
            <a v-on:click.stop="removeFilter(filter)" class="filter-badge">
              {{filter.name}}
              <span>x</span>
            </a>
          </div>
          <div v-for="(key, index) in Object.keys(this.searchResult.facets)" :key="'A' + index">
            <div v-if="searchResult.facets[key].length > 1">
              <collapse
                :collapse="[ getFilterCategoryDisplayName(key) ]"
                :defaultCollapse="getFilterCategoryCollapsed(key)"
                icon="keyboard_arrow_down"
              >
                <template slot="md-collapse-pane-1">
                  <div
                    v-for="(facet, index2) in searchResult.facets[key].slice(0,10)"
                    :key="index2"
                  >
                    <a
                      class="filter-value"
                      v-if="facet.value.length > 0"
                      v-on:click.stop="filterByFacet(key,facet.value)"
                    >{{facet.value}} ({{facet.count}})</a>
                  </div>
                  <div v-if="searchResult.facets[key].length > 10">
                    <span :id="'show-' + key" v-on:click="expand(key)" class="show-all">Show all...</span>
                    <div :id="'facet-container-' + key" style="display:none">
                      <div
                        v-for="(facet, index2) in searchResult.facets[key].slice(10)"
                        :key="index2"
                      >
                        <a
                          class="filter-value"
                          v-if="facet.value.length > 0"
                          v-on:click.stop="filterByFacet(key,facet.value)"
                        >{{facet.value}} ({{facet.count}})</a>
                      </div>
                    </div>
                  </div>
                </template>
              </collapse>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-80">
      <md-card>
        <md-card-header class="md-card-header-icon">
          <div class="card-icon">
            <md-icon>apps</md-icon>
          </div>
          <h4 class="title">
            <span
              v-if="searchString.length == 0 && searchList.length == 0 && this.$store.state.filters.length > 0"
              class="indent"
            >
              <md-button
                v-if="this.filterIsFavorite"
                @click="removeCurrentFilterFromFavorite"
                class="md-simple md-just-icon favorite-button"
                title="Remove from favorite filters"
              >
                <md-icon>favorite</md-icon>
              </md-button>
              <md-button
                v-else
                @click="addCurrentFilterAsFavorite"
                class="md-simple md-just-icon favorite-button"
                title="Add as favorite filter"
              >
                <md-icon>favorite_border</md-icon>
              </md-button>
            </span>
            <span v-if="searchString.length > 0">Search&nbsp;"{{searchString}}"&nbsp;</span>
            <span v-if="searchList.length > 0">Reference List&nbsp;</span>
            <span
              v-if="searchString.length == 0 && searchList.length == 0 && this.$store.state.filters.length == 0"
            >All Content&nbsp;</span>
            <span
              v-if="(searchString.length > 0 || searchList.length > 0) && this.$store.state.filters.length > 0"
            >>&nbsp;</span>
            <span
              v-for="(filter, index) in this.$store.state.filters"
              :key="index"
            >{{filter.facet.displayName || filter.facet.value}}&nbsp;>&nbsp;</span>
            ({{this.searchResult.count}})
            <md-button @click="clearSearch" class="md-simple md-just-icon clear-filter">
              <md-icon>close</md-icon>
            </md-button>
          </h4>
          <div class="md-layout tools">
            <!-- tools -->
            <div class="md-layout-item md-size-80">
              <md-button class="md-simple" v-on:click="showReferenceModalPopup">
                <md-icon>add_box</md-icon>
                <span>Search from reference list</span>
              </md-button>
              <div style="display: inline-block;">
                <md-button  class="md-simple" :disabled="disableAddAllButton" @click="addAllToCart">
                  <md-icon>add_shopping_cart</md-icon>
                  <span>
                    Add all to cart
                  </span>
                </md-button>
                <md-tooltip md-direction="top" v-show="disableAddAllButton">Cannot add to cart more than {{$store.state.activeEnvironment.cartLimit}} items</md-tooltip>
              </div>
              <md-button class="md-simple" @click="clearCart">
                <md-icon>remove_shopping_cart</md-icon>
                <span>Clear cart</span>
              </md-button>
              <md-button class="md-simple" v-on:click="openCart()">
                <md-icon>shopping_cart</md-icon>
                <span>View cart</span>
              </md-button>
            </div>
            <!-- <md-button class="md-simple">
              <md-icon>arrow_drop_down</md-icon>
              <span>Sort By (Modified)</span>
            </md-button>-->
            <div class="md-layout-item md-size-20">
              <drop-down>
                <div class="md-group">
                  <md-button
                    class="md-simple md-just-icon sort-arrow"
                    @click.stop="changeSortOrder"
                  >
                    <md-icon v-if="this.$store.state.sortOrder == 'desc'">arrow_downward</md-icon>
                    <md-icon v-else>arrow_upward</md-icon>
                  </md-button>
                  <md-button class="md-simple select-sort-property">
                    <span>{{sortLabel}}</span>
                  </md-button>
                </div>
                <ul class="dropdown-menu">
                  <li class="sort-item">
                    <a href="javascript:void(0)" @click="changeSortProperty">{{changeSortLabel}}</a>
                  </li>
                </ul>
              </drop-down>
            </div>
          </div>
        </md-card-header>
        <md-card-content class="filter-column">
          <div class="md-layout">
            <div v-if="showspinner" class="loading-spinner">
              <dot-loader size="120px"></dot-loader>
            </div>
            <md-card
              v-for="(result, index) in this.documents"
              :key="index"
              class="md-layout-item md-medium-size-50 md-xsmall-size-50 md-size-15 content-area"
            >
              <a v-on:click.stop="showModalare(result.document)">
                <span
                  class="card-description"
                  :title="result.document.description"
                >{{result.document.description}}</span>
                <div v-if="result.document.type == 'media'" class="datacard-icon">
                  <i class="md-icon md-icon-font md-theme-default transparent-icon">camera_alt</i>
                </div>
                <div class="card-image-container">
                  <img v-if="result.document.thumbnail != ''" :src="result.document.thumbnail + imageSeed(result.document.thumbnail)" @error="reloadImg" />
                  <img class="no-image" v-else src="/img/no-image.png" />
                </div>
                <div class="card-title" :title="result.document.name">{{result.document.name}}</div>
              </a>
              <div class="cart-button">
                <div style="display: inline-block;" v-if="existsInCart(result.document)">
                  <md-button
                    v-on:click="addToCart(result.document)"
                    class="md-sm add-to-cart"
                    :disabled="$store.state.cart.length >= $store.state.activeEnvironment.cartLimit"
                  >Add to cart</md-button>
                  <md-tooltip md-direction="top" v-show="$store.state.cart.length >= $store.state.activeEnvironment.cartLimit">Cannot add to cart more than {{$store.state.activeEnvironment.cartLimit}} items</md-tooltip>
                </div>
                <div style="display: inline-block;" v-else>
                  <md-button
                    v-on:click="removeFromCart(result.document)"
                    class="md-sm remove-from-cart"
                  >Remove</md-button>
                </div>
              </div>
            </md-card>
            <modal v-if="showModal" @close="modalHide">
              <template slot="header">
                <h4 class="modal-title">{{this.details.name}}</h4>
                <md-button
                  class="md-simple md-just-icon md-round modal-default-button"
                  @click="modalHide"
                >
                  <md-icon>clear</md-icon>
                </md-button>
              </template>

              <template slot="body">
                <div class="popup-container">
                  <div v-if="downloading" class="center-div">
                    <dot-loader></dot-loader>
                  </div>
                  <div v-else class="md-layout">
                    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-75">
                      <div class="md-layout">
                        <div
                          class="md-layout-item md-medium-size-50 md-xsmall-size-100 center-image"
                          v-bind:class="[(this.details.media.length > 1) ? 'md-size-80' : 'md-size-100' ]"
                        >
                          <div
                            v-if="this.details.selectedMedia && this.details.selectedMedia.isVideo"
                            class="flex-center"
                          >
                            <video controls controlsList="nodownload" preload="metadata">
                              <source :src="this.details.selectedMedia.url" type="video/mp4" />>
                            </video>
                          </div>
                          <div v-else class="flex-center">
                            <!-- <img :src="this.details.selectedMedia.url"> -->
                            <table width="100%" height="100%" align="center" valign="center">
                              <tr>
                                <td>
                                  <img
                                    v-if="this.details.selectedMedia.url != null"
                                    id="selectedImage"
                                    style="max-height: 400px;"
                                    :src="this.details.selectedMedia.url + imageSeed(this.details.selectedMedia.url)"
                                  />
                                  <img class="no-image" v-else src="/img/no-image.png" />
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>
                        <div
                          v-if="this.details.media.length > 1"
                          class="modal-text-area center-image md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-20"
                        >
                          <md-card
                            v-for="(m, index) in this.details.media"
                            :key="index"
                            class="popup-media-box"
                          >
                            <div
                              class="card-image-container-popup"
                              v-on:click="details.selectedMedia = m"
                            >
                              <img :src="m.thumbnail + imageSeed(m.thumbnail)" />
                            </div>
                            <div class="card-title-popup">
                              <span :title="m.name">{{m.name}}</span>
                            </div>
                          </md-card>
                        </div>
                      </div>
                    </div>

                    <div
                      class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 media-text modal-text-area"
                    >
                      <!-- <md-field
                        v-for="(key, index) in Object.keys(this.details.properties)"
                        :key="index"
                      >-->
                      <div
                        style="max-width: 700px;"
                        v-for="(key, index) in Object.keys(this.details.properties)"
                        :key="index"
                      >
                        <div v-if="details.properties[key]" class="details-label">{{details.map[key].label}}</div>
                        <div v-if="details.properties[key]" class="details-field">{{details.properties[key]}}</div>
                      </div>
                      <!-- <label class="col-md-3 bmd-label-floating">{{key}}</label>
                      <div class="details-field" v-model="details.properties[key]" >-->
                      <!-- <md-input
                          disabled="disabled"

                          type="text"
                          :title="details.properties[key]"
                      ></md-input>-->
                      <!-- </md-field> -->
                    </div>
                  </div>
                </div>
              </template>
              <template slot="footer">
                <div style="display: inline-block;" v-if="keyExistsInCart(this.details.id)">
                  <md-button
                    v-on:click="addToCartByKey()"
                    class="md-sm add-to-cart"
                    :disabled="$store.state.cart.length >= $store.state.activeEnvironment.cartLimit"
                  >Add to cart</md-button>
                  <md-tooltip md-direction="top" v-show="$store.state.cart.length >= $store.state.activeEnvironment.cartLimit">Cannot add to cart more than {{$store.state.activeEnvironment.cartLimit}} items</md-tooltip>
                </div>
                <div style="display: inline-block;" v-else>
                  <md-button
                    class="md-sm remove-from-cart"
                    v-on:click="removeFromCartByKey()"
                  >Remove from Cart</md-button>
                </div>
                <md-button class="md-simple" @click="getPreviousDetail">&lt; Previous</md-button>
                <md-button class="md-simple" @click="getNextDetail">Next ></md-button>
                <md-button class="md-simple" @click="modalHide">Close</md-button>
              </template>
            </modal>
          </div>
        </md-card-content>
      </md-card>
    </div>

    <modal v-if="showMissingModal" @close="missingModalHide">
      <template slot="header">
        <h4 class="modal-title">The following references could not be found</h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="missingModalHide"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <textarea v-model="missingReferenceList" class="multi-input"></textarea>

        <div class="modal-button">
          <md-button class="md-sm clear-content" @click="missingModalHide">Close</md-button>
        </div>
      </template>
    </modal>
    <modal v-if="showReferenceModal" @close="modalReferenceHide">
      <template slot="header">
        <h4 class="modal-title">Search for list of references</h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="modalReferenceHide"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <textarea
          v-model="searchList"
          class="multi-input"
          placeholder="Paste reference numbers list here"
        ></textarea>

        <div class="cart-button2">
          <md-button class="md-sm clear-content" v-on:click="clearReferenceList">Clear</md-button>
          <md-button class="md-sm open-result" v-on:click="openList">Search</md-button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import SearchService from "@/services/SearchService";
import DetailService from "@/services/DetailService";
import UserService from "@/services/UserService";
import $ from "jquery";
import { Collapse, Modal, DotLoader } from "@/components";
export default {
  data() {
    return {
      query: this.$route.params.query,
      documents: [],
      searchResult: {
        count: 0,
        results: [],
        facets: [],
        continuationToken: []
      },
      bottom: false,
      showModal: false,
      rotate: 0,
      showMissingModal: false,
      showReferenceModal: false,
      selected: [],
      details: {
        name: "Loading...",
        type: ""
      },
      downloading: false,
      filterIsFavorite: false,
      addToCart2: [],
      missingReferenceList: [],
      sortLabel: "Sort By (Latest Update)",
      changeSortLabel: "Sort By (Name)",
      showspinner: false,
      failedImages: [],
      showCartLimitTooltip: false
    };
  },
  components: {
    Collapse,
    Modal,
    DotLoader
  },
  computed: {
    searchString: {
      get: function() {
        return this.$store.state.searchString;
      }
    },
    searchList: {
      get: function() {
        return this.$store.state.searchList;
      },
      set: function(newValue) {
        this.$store.commit("setSearchList", newValue);
      }
    },
    sortOrder: {
      get: function() {
        return this.$store.state.sortOrder;
      }
    },
    searchAction: {
      get: function() {
        return this.$store.state.searchAction;
      }
    },
    disableAddAllButton: {
      get: function() {
        if(!this.searchResult || !this.$store.state.activeEnvironment)
          return true;
        this.showCartLimitTooltip = this.searchResult.count + this.$store.state.cart.length > this.$store.state.activeEnvironment.cartLimit;
        return this.searchResult.count + this.$store.state.cart.length > this.$store.state.activeEnvironment.cartLimit;
      }
    },
    imageSeed() {
      return url => {
        return url.indexOf("?") > -1 ? "&" + performance.now() : "?" + performance.now();
      }
    }
  },
  mounted() {
    let self = this;
    this.decideQueryAction();
    this.checkIfFilterIsFavorite();
    window.addEventListener("keyup", function(event) {
      if (!self.showModal) {
        return;
      }
      if (event.keyCode == 37) {
        self.getPreviousDetail();
      } else if (event.keyCode == 39) {
        self.getNextDetail();
      } else if (event.keyCode == 27) {
        self.modalHide();
      }
      //self.myMethod(ev); // declared in your component methods
    });
  },
  watch: {
    bottom(bottom) {
      if (bottom) {
        this.loadMoreResults();
      }
    },
    searchAction(value) {
      if (value) {
        this.decideQueryAction();
      }
      this.$store.commit("setSearchAction", false);
    }
  },
  created() {
    window.addEventListener("scroll", () => {
      this.bottom = this.bottomVisible();
    });
  },
  methods: {
  reloadImg(e){
    let imgUrl = e.target.src;
    if(this.failedImages.indexOf(imgUrl) > -1)
      return;

    e.target.src = '';
    e.target.src = imgUrl;
    this.failedImages.push(imgUrl);
  },
    changeSortProperty() {
      if (this.$store.state.sortProperty == "Modified") {
        this.$store.commit("setSortProperty", "Name");
        this.sortLabel = "Sort By (Name)";
        this.changeSortLabel = "Sort By (Latest Update)";
      } else {
        this.$store.commit("setSortProperty", "Modified");
        this.sortLabel = "Sort By (Latest Update)";
        this.changeSortLabel = "Sort By (Name)";
      }

      this.decideQueryAction();
    },
    changeSortOrder() {
      if (this.$store.state.sortOrder == "asc") {
        this.$store.commit("setSortOrder", "desc");
      } else {
        this.$store.commit("setSortOrder", "asc");
      }

      this.decideQueryAction();
    },
    expand(key) {
      var x = document.getElementById("facet-container-" + key);
      x.style.display = "block";

      var y = document.getElementById("show-" + key);
      y.style.display = "none";
    },
    modalReferenceHide: function() {
      this.showReferenceModal = false;

      $("body").css("overflow", "auto");
    },
    clearReferenceList() {
      this.searchList = "";
      this.decideQueryAction();
    },
    showReferenceModalPopup() {
      this.showReferenceModal = true;
      $("body").css("overflow", "hidden");
    },
    async openList() {
      this.$store.commit("clearFilters");
      this.$store.commit("setSearchString", "");
      this.modalReferenceHide();
      // this.loadList();
      this.decideQueryAction();
    },
    clearSearch() {
      this.$store.commit("clearFilters");
      this.$store.commit("setSearchString", "");
      this.$store.commit("setSearchList", "");
      this.$store.commit("setSearchSinceUtc", null);
      this.decideQueryAction();
    },
    async addAllToCart() {
      let self = this;

      if (this.searchResult.continuationToken == null) {
        this.documents.forEach(function(r) {
          let obj = self.$store.state.cart.find(
            obj => obj.id == r.document.id
          );

          if (obj == undefined) {
            self.$store.commit("addToCart", r.document);
          }
        });

        return;
      }

      this.showspinner = true;
      const response = await SearchService.GetAllResultsByFilter();

      response.data.result.results.forEach(function(r) {
        let obj = self.$store.state.cart.find(
          obj => obj.id == r.document.id
        );

        if (obj == undefined) {
          self.$store.commit("addToCart", r.document);
        }
      });

      this.showspinner = false;
    },
    async addCurrentFilterAsFavorite() {
      if (!this.checkIfFilterIsFavorite()) {
        this.filterIsFavorite = true;

        var filters = JSON.parse(JSON.stringify(this.$store.state.filters));

        // filters.push({"filters": this.$store.state.filters, "id": '123'});

        const response = await UserService.SetFavoriteFilters(filters, this.$store.state.activeEnvironment.id);

        this.$store.commit("replaceFavoriteFilters", response.data.result);

        this.notifyVue("Favorite filter added");
      }
    },
    async removeCurrentFilterFromFavorite() {
      if (this.checkIfFilterIsFavorite()) {
        var id = this.getSelectedFavoriteFilterId();
        this.filterIsFavorite = false;

        const response = await UserService.RemoveFavoriteFilter(id);

        this.$store.commit("replaceFavoriteFilters", response.data.result);

        this.notifyVue("Favorite filter removed");
      }
    },
    notifyVue(message) {
      // var color = 'info'
      var color = "pz";
      this.$notify({
        message: message,
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: color,
        timeout: 10000
      });
    },
    getSelectedFavoriteFilterId() {
      var isfavorite = false;
      var selectedId = null;

      this.$store.state.user.favoriteFilters.some(f => {
        isfavorite = this.filtersAreEqual(f.filters, this.$store.state.filters);

        if (isfavorite) {
          selectedId = f.id;
          return true;
        }
      });

      return selectedId;
    },
    checkIfFilterIsFavorite() {
      var isfavorite = false;

      this.$store.state.user.favoriteFilters.some(f => {
        isfavorite = this.filtersAreEqual(f.filters, this.$store.state.filters);

        if (isfavorite) {
          return true;
        }
      });

      this.filterIsFavorite = isfavorite;
      return isfavorite;
    },
    filtersAreEqual(favorite, selected) {
      // alert(JSON.stringify(favorite) + "\n\n" + JSON.stringify(selected));

      if (favorite.length != selected.length) {
        return false;
      }

      var areEqual = true;

      for (var i = 0; i < selected.length; i++) {
        if (
          favorite.filter(
            e =>
              e.facet.key === selected[i].facet.key &&
              e.facet.value === selected[i].facet.value
          ).length > 0
        ) {
          /* vendors contains the element we're looking for */
        } else {
          areEqual = false;
        }
      }

      return areEqual;
    },
    getNextDetail() {
      let current = this.documents.find(
        obj => obj.document.id == this.details.id
      );

      var index = this.documents.indexOf(current);

      if (index + 1 == this.documents.length) {
        index = -1;
      }

      let next = this.documents[index + 1];

      this.downloading = true;
      this.getDetails(next.document.id, next.document.type);
    },
    getPreviousDetail() {
      let current = this.documents.find(
        obj => obj.document.id == this.details.id
      );

      var index = this.documents.indexOf(current);

      if (index - 1 < 0) {
        index = this.documents.length;
      }

      let previous = this.documents[index - 1];
      this.downloading = true;
      this.getDetails(previous.document.id, previous.document.type);
    },
    showModalare(document) {
      this.selected = document;
      this.showModal = true;
      this.getDetails(document.id, document.type);

      this.downloading = true;
      $("body").css("overflow", "hidden");
    },

    modalHide: function() {
      this.showModal = false;
      $("body").css("overflow", "auto");
    },
    missingModalHide: function() {
      this.showMissingModal = false;
      $("body").css("overflow", "auto");
    },
    async getDetails(id, type) {
      this.details.name = "Loading...";
      const response = await DetailService.GetDetails(id, type);

      this.details = response.data.result;
      console.log(this.details);

      this.downloading = false;
    },
    async loadMoreResults() {
      if (this.searchResult.continuationToken == null) {
        return;
      }
      const response = await SearchService.ContinueSearch(
        this.searchResult.continuationToken
      );

      this.searchResult = response.data.result;

      this.documents = this.documents.concat(response.data.result.results);
    },
    getFilterCategoryDisplayName(category) {
      const facetName = this.searchResult.facets[category][0].name;
      if (facetName) return facetName;

      return category;
    },
    getFilterCategoryCollapsed(category) {
       let obj = this.$store.state.facets.find(obj => obj.id == category);

      if (obj != undefined) {
        var index = this.$store.state.facets.indexOf(obj);

        if (this.$store.state.facets[index].defaultCollapse){
          return 0;
        }
      }



      return 1;
    },
    bottomVisible() {
      const scrollY = window.scrollY;
      const visible = document.documentElement.clientHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const bottomOfPage = visible + scrollY + 200 >= pageHeight;
      return bottomOfPage || pageHeight < visible;
    },
    async decideQueryAction() {
      // if (this.$store.state.searchList.length > 0) {
      //   this.loadList();
      //   return;
      // }
      // var response;
      // if (this.$store.state.filters.length > 0) {
      //   var filter = "";

      //   this.$store.state.filters.forEach(function(f) {
      //     if (filter.length == 0) {
      //       filter = f.filter;
      //     } else {
      //       filter += " and " + f.filter;
      //     }
      //   });

      //   response = await SearchService.Search(
      //     filter,
      //     this.searchString
      //   );
      // } else if (this.$store.state.searchList.length > 0) {
      //   this.loadList();
      // } else {
      var response = await SearchService.Search();
      //}

      this.searchResult = response.data.result;
      this.documents = response.data.result.results;
    },
    async filterByFacet(key, value) {
      this.$store.commit("addFilter", {
        name: this.getFilterCategoryDisplayName(key) + ": " + value,
        facet: { key: key, value: value }
      });

      this.checkIfFilterIsFavorite();

      const response = await SearchService.Search();

      this.searchResult = response.data.result;

      this.documents = response.data.result.results;
    },

    async removeFilter(f) {
      this.$store.commit("removeFilter", f);

      this.checkIfFilterIsFavorite();

      const response = await SearchService.Search();

      this.searchResult = response.data.result;

      this.documents = response.data.result.results;
    },
    addToCart(document) {
      this.$store.commit("addToCart", document);
    },
    removeFromCart(document) {
      this.$store.commit("removeFromCart", document);
    },
    clearCart() {
      this.$store.commit("clearCart");
    },
    // Actually returns true if a document is not in the cart
    existsInCart(document) {
      let obj = this.$store.state.cart.find(
        obj => obj.id == document.id
      );

      return obj == undefined;
    },
    keyExistsInCart(id) {
      let obj = this.$store.state.cart.find(obj => obj.id == id);

      return obj == undefined;
    },
    addToCartByKey() {
      let obj = this.documents.find(
        obj => obj.document.id == this.details.id
      );
      this.$store.commit("addToCart", obj.document);
    },
    removeFromCartByKey() {
      let obj = this.documents.find(
        obj => obj.document.id == this.details.id
      );
      this.$store.commit("removeFromCart", obj.document);
    },
    openCart() {
      if (this.$route.params.cartId) {
        this.$router.push({ name: 'SharedCart', params: { id: this.$route.params.cartId, loadCartItems: 0 }})
      } else {
        this.$router.push({ name: 'Cart'})
      }
    }
  }
};
</script>

<style scoped>
.loading-spinner {
  position: absolute;
  top: 10px;
  left: 40%;
  z-index: 10;
}

.cart-button2 {
  position: absolute;
  bottom: 10px;
  right: 22px;
}

.cart-button2 button {
  margin-left: 5px;
}

.modal-button {
  position: absolute;
  bottom: 10px;
  right: 22px;
}

.datacard-icon {
  position: absolute;
  top: 0;
  right: 5px;
}

.clear-filter {
  margin-top: -8px;
  margin-left: -10px;
}

.favorite-button {
  position: absolute;
  top: 6px;
  left: 75px;
}

.indent {
  margin-right: 15px;
}

.tools {
  text-align: left;
}

.filter {
  margin: 0;
  margin-left: 8px;
  padding: 10px;
  border: none;
}

.overflow {
  height: 500px;
  overflow: auto;
}

.media-container {
  margin-left: 50px;
}

.image-text {
  width: 300px;
}

.image-text {
  float: left;
}
.popup-container {
  display: block;
  width: 100%;
  height: 470px;
}

.popup-container div img {
  max-height: 100%;
  width: auto;
  text-align: center;
}
.center-div {
  margin: 0 auto;
  width: 100px;
  padding-top: 200px;
}
.filter-badge {
  display: inline-block;
  border-radius: 4px;
  padding: 8px;
  text-transform: uppercase;
  font-size: 11px;
  font-weight: 500;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  background-color: white;
  margin-bottom: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.filter-badge span {
  text-transform: none;
  position: relative;
  left: 6px;
  bottom: 1px;
  padding-right: 5px;
  font-size: 10px;
}

.filter-value {
  cursor: pointer;
}
.content-area {
  margin: 15px;
  padding: 10px;

  min-height: 230px;
  max-height: 230px;
  min-width: 160px;
  max-width: 160px;
  cursor: pointer;
}

.card-title-popup {
  width: 110px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: center;
  font-size: 10px;
}

.card-title {
  width: 140px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.content-area div {
  margin-top: 5px;
  font-size: 12px;
  text-align: center;
}

.cart-button {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.card-image-container {
  height: 140px;
  width: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-image-container img {
  /*zoom: 2;*/

  display: block;
  margin: auto;

  height: auto;
  max-height: 100px;

  width: auto;
  max-width: 100px;
}

.card-image-container-popup {
  height: 100px;
  width: 100px;
  margin: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.card-image-container-popup img {
  /*zoom: 2;*/

  display: block;
  margin: auto;

  height: auto;
  max-height: 100%;

  width: auto;
  max-width: 100%;
}

.filter-column {
  min-height: 500px;
}
.modal-text-area {
  height: 460px;
  overflow: auto;
  overflow-x: hidden;
}

.center-image {
  text-align: center;
}

.popup-media-box {
  width: 110px;
}

.video-preview {
  max-height: 460px;
}

.card-description {
  position: absolute;
  top: 3px;
  text-align: center;
  width: 140px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 12px;
}

.show-all {
  font-weight: bold;
  cursor: pointer;
}

.details-field {
  border-bottom: solid 1px #ccc;
  padding-bottom: 3px;
  /*text-overflow: ellipsis;
  overflow: hidden; 
  white-space: nowrap;*/
}

.details-label {
  color: #aaa;
  font-size: 11px;
  padding-top: 3px;
}

.flex-center video {
  height: 460px;
}

.flex-center {
  height: 460px;
}

.no-image {
  opacity: 0.6;
}
</style>
